import React from "react";
import "./Allbook.css";
import dp from "../../images/book1.svg";
import gift from "../../images/gift.svg";
import { END_URL,IMG_URL,SITE_URL } from "../../config";
function Allbook({ categoryId,ebook_list_content,ebook_data = [] }) {
  return (
    <div className="row">

      {categoryId =='all' && (

        <div className="allbook-title" dangerouslySetInnerHTML={{__html:ebook_list_content}} />
      )}
       
      <div className="allbook-box">

         {ebook_data?.length > 0 ? (

          ebook_data.map((book) => (

            <div  className="allbook-single"  key={book.id}>
             
              <div className="image-box">

                <img src={`${IMG_URL}/d0/${book.book_cover}`} alt={book.title}  />
                
              </div>

              {book.type ===1  && (

                  <div className="adaptor-icon">

                    <span>

                      <img src={gift} alt="" />

                    </span>

                      <p> Free </p>
                  </div>
                )}

              <div className="book-cart">

                <h5> {book.title} </h5>
                  
                <p>{book.archetype}</p>

                <div className="ebook-des" dangerouslySetInnerHTML={{__html:book.short_description}}/>
                 
                <div>

                  <span>

                    {"★".repeat(Math.round(book.rating || 0))}

                  </span>

                   <p> {book.rating || 0} {book?.rating_count &&(<span>({book?.rating_count})</span>)} </p>  

                </div>

                <h6>

                  ${parseFloat(book.price || 0).toFixed(2)}

                  {parseFloat(book.price || 0) <= 0 && (

                    <span>
                      {} Free
                    </span>

                  )}

                </h6>

              </div>

              <a href={`/ebook/${book.slug}`}  className="allbook-btn">
                
                {book.button_label}

              </a>

            </div>

          ))

        ) : (

            <div className="col-12 text-center">

                <p>
                  No books available
                </p>

            </div>

        )}

        {/* <div className="allbook-single">
          <div className="image-box">
            <img src={dp} alt="" />
          </div>
          <div class="adaptor-icon">
            <span>
              <img src={gift} alt="" />
            </span>
            <p>Free Book of the Week</p>
          </div>

          <div className="book-cart">
            <h5>The Adapter </h5>
            <p>Stay steady and flexible in a fast-changing world</p>
            <div>
              <span>★★★★★</span>
              <p>
                4.8 <span>(128)</span>
              </p>
            </div>
            <h6>
              $0.00 <span>Free</span>
            </h6>
          </div>

          <a href="#no" className="allbook-btn">
            View Book
          </a>
        </div> */}
        
      {/*
        <div className="allbook-single">
          <div className="image-box">
            <img src={dp} alt="" />
          </div>
          <div class="adaptor-icon">
            <span>
              <img src={gift} alt="" />
            </span>
            <p>Free Book of the Week</p>
          </div>

          <div className="book-cart">
            <h5>The Adapter </h5>
            <p>Stay steady and flexible in a fast-changing world</p>
            <div>
              <span>★★★★★</span>
              <p>
                4.8 <span>(128)</span>
              </p>
            </div>
            <h6>
              $0.00 <span>Free</span>
            </h6>
          </div>

          <a href="#no" className="allbook-btn">
            View Book
          </a>
        </div>

        <div className="allbook-single">
          <div className="image-box">
            <img src={dp} alt="" />
          </div>
          <div class="adaptor-icon">
            <span>
              <img src={gift} alt="" />
            </span>
            <p>Free Book of the Week</p>
          </div>

          <div className="book-cart">
            <h5>The Adapter </h5>
            <p>Stay steady and flexible in a fast-changing world</p>
            <div>
              <span>★★★★★</span>
              <p>
                4.8 <span>(128)</span>
              </p>
            </div>
            <h6>
              $0.00 <span>Free</span>
            </h6>
          </div>

          <a href="#no" className="allbook-btn">
            View Book
          </a>
        </div>

        <div className="allbook-single">
          <div className="image-box">
            <img src={dp} alt="" />
          </div>
          <div class="adaptor-icon">
            <span>
              <img src={gift} alt="" />
            </span>
            <p>Free Book of the Week</p>
          </div>

          <div className="book-cart">
            <h5>The Adapter </h5>
            <p>Stay steady and flexible in a fast-changing world</p>
            <div>
              <span>★★★★★</span>
              <p>
                4.8 <span>(128)</span>
              </p>
            </div>
            <h6>
              $0.00 <span>Free</span>
            </h6>
          </div>

          <a href="#no" className="allbook-btn">
            View Book
          </a>
        </div>

        <div className="allbook-single">
          <div className="image-box">
            <img src={dp} alt="" />
          </div>
          <div class="adaptor-icon">
            <span>
              <img src={gift} alt="" />
            </span>
            <p>Free Book of the Week</p>
          </div>

          <div className="book-cart">
            <h5>The Adapter </h5>
            <p>Stay steady and flexible in a fast-changing world</p>
            <div>
              <span>★★★★★</span>
              <p>
                4.8 <span>(128)</span>
              </p>
            </div>
            <h6>
              $0.00 <span>Free</span>
            </h6>
          </div>

          <a href="#no" className="allbook-btn">
            View Book
          </a>
        </div> */}

      </div>
    </div>
  );
}

export default Allbook;
